import * as React from 'react';
import { EditorState } from 'draft-js';
import RichTextEditor from '../input/RichTextEditor';

export interface RichTextEditorWithScrollbarProps {
    onEditorChange?: (editorState: EditorState) => void;
    placeholder?: string;
    readOnly?: boolean;
    editorState: EditorState;
    classes?: string;
}

class RichTextEditorWithScrollbar extends React.Component<RichTextEditorWithScrollbarProps, any> {

    constructor(props: RichTextEditorWithScrollbarProps) {
        super(props);
        this.getClasses = this.getClasses.bind(this);
    }

    getClasses() {
        if (this.props.classes === undefined) {
            return 'fixed-height-medium';
        }
        return this.props.classes;
    }

    render() {
        return (
            <div className={'rich-textbox-scrollbar'}>
                <div className={this.getClasses()}>
                    <RichTextEditor
                        readOnly={this.props.readOnly}
                        editorState={this.props.editorState}
                        onEditorChange={this.props.onEditorChange}
                        placeholder={this.props.placeholder}
                    />
                </div>
            </div>
        );
    }
}

export default RichTextEditorWithScrollbar;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/RichTextEditorWithScrollbar.tsx